import { render, staticRenderFns } from "./collapsed-menu.vue?vue&type=template&id=a662aa16&scoped=true&"
import script from "./collapsed-menu.vue?vue&type=script&lang=js&"
export * from "./collapsed-menu.vue?vue&type=script&lang=js&"
import style0 from "./collapsed-menu.vue?vue&type=style&index=0&id=a662aa16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a662aa16",
  null
  
)

export default component.exports